import initialState from './initialState';

export function fileUploadSuccess(
  state = initialState.fileUploadSuccess,
  action,
) {
  switch (action.type) {
    case 'UPLOAD_DOCUMENT_SUCCESS':
      return action.isUploaded;
    default:
      return state;
  }
}

export function fileUploadErrored(
  state = initialState.fileUploadErrored,
  action,
) {
  switch (action.type) {
    case 'UPLOAD_DOCUMENT_FAIL':
      return action.error;
    default:
      return state;
  }
}

export function fileIsUploading(state = initialState.fileIsUploading, action) {
  switch (action.type) {
    case 'UPLOAD_DOCUMENT_UPLOADING':
      return action.isUploading;
    default:
      return state;
  }
}

export function cafOfferListHasErrored(
  state = initialState.cafOfferListHasErrored,
  action,
) {
  switch (action.type) {
    case 'CAF_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function cafOfferListIsLoading(
  state = initialState.cafOfferListIsLoading,
  action,
) {
  switch (action.type) {
    case 'CAF_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function cafOfferList(state = initialState.cafOfferList, action) {
  switch (action.type) {
    case 'CAF_LIST_FETCH_DATA_SUCCESS':
      return action.cafOfferList;
    case 'CLEAR_CAF_LIST_DATA':
      return [];
    default:
      return state;
  }
}

export function cafHistoryListHasErrored(
  state = initialState.cafHistoryListHasErrored,
  action,
) {
  switch (action.type) {
    case 'CAF_HISTORY_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function cafHistoryListIsLoading(
  state = initialState.cafHistoryListIsLoading,
  action,
) {
  switch (action.type) {
    case 'CAF_HISTORY_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function cafHistoryList(state = initialState.cafHistoryList, action) {
  switch (action.type) {
    case 'CAF_HISTORY_LIST_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function purchaseRebateCafListHasErrored(
  state = initialState.purchaseRebateCafListHasErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_CAF_HISTORY_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function purchaseRebateCafListIsLoading(
  state = initialState.purchaseRebateCafListIsLoading,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_CAF_HISTORY_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function purchaseRebateCafHistoryList(
  state = initialState.purchaseRebateCafHistoryList,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_CAF_HISTORY_LIST_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}
